import Text from 'components/Text';
import { observer } from 'mobx-react-lite';
import useStores from 'stores/helpers/useStores';
import styled, { useTheme } from 'styled-components';
import { ITeam } from 'types/Team';

const TeamName = styled(Text)`
  display: block;
  flex: 1;
  padding-left: 24px;

  &:first-child {
    padding-left: 0;
    padding-right: 24px;
  }
`;

const Bolded = styled.span`
  font-weight: bold;
  color: ${(props) => props.theme.palette.dark[800]};
`;

interface Props {
  team: ITeam;
  title: string;
}

export const TeamTitle: React.FC<Props> = observer(({ team, title }) => {
  const theme = useTheme();
  const { matchStore } = useStores();

  const sum = team.players.reduce((acc, curr) => acc + (curr.score || 0), 0);
  const avg = team.players.length > 0 ? sum / team.players.length : 0;

  return (
    <TeamName
      variant="headline1"
      textTransform="uppercase"
      color={theme.palette.dark[200]}
    >
      {title}
      {matchStore.showRatings && <Bolded> (AVG: {avg.toFixed(2)})</Bolded>}
    </TeamName>
  );
});
